// Segnaposti da configurare prima del lancio
export const WHATSAPP_NUMBER = "390000000000"; // [NUMERO WHATSAPP]
export const CONTACT_EMAIL = "info@example.com"; // [EMAIL]
export const CALENDAR_EMBED_URL = ""; // [CAL.COM / CALENDLY EMBED URL]
